import { isMimickingUser } from "@/authentication/token-storage";
import { BACKEND_URL } from "@/constants";

export default async function downloadAttachment(reportUri: string) {
  const mimickingUser = isMimickingUser();

  // Just open in a new tab
  if (undefined === mimickingUser) {
    window.open(`${BACKEND_URL}/${reportUri}`, "_blank");
    return Promise.resolve();
  }

  fetch(`${BACKEND_URL}/${reportUri}`, {
    credentials: "include",
    headers: {
      "X-Switch-User": mimickingUser,
    },
  })
    .then(response => response.blob())
    .then(blob => {
      const _url = window.URL.createObjectURL(blob);
      window.open(_url, "_blank")?.focus();
    });
}
